// src/pages/Produtos/profiles/vtr.js
export const vtrProfile = {
    id: 'vtr',
    layout: 'vtr',
    labelForm: 'Gestão de Veículos',
    tabs: {
        cabecalho: { enabled: true },
        industria: { enabled: false },
        materiaPrima: { enabled: false },
        modoProducao: { enabled: false },
        embalagens: { enabled: true },
        caracteristicas: { enabled: false },
        bens: { enabled: true },
        mobilia: { enabled: false },
        imagens: { enabled: true },
    },

    uiTabs: {
        cabecalho: {
            titles: { grid: 'detalhes do cadastro do veículo' },
            labels: { grid: 'Informções do Veículo' },
            show: {
                //1ª div cabeçalho
                industria: false,
            },
        },
        embalagem: {
            titles: { grid: 'embalagens aplicadas ao veículo', codigoBarras: 'utilize o renavam por ser chave única do veículo' },
            labels: { form: 'Informações do veículo', codigoBarras: 'Cod Barra / RENAVAN' },
        },
        bens: {
            titles: { grid: 'Informações específicas do veículo' },
            labels: {
                grid: 'Veículo',
            },
            show: { veiculo: true, imovel: false, bemMovel: false },
        },
    },

    parametros: {
        defaultsProduto: {
            bem: true,
            vtr: true,
            imovel: false,
            industria: false,
            materiaPrima: false,
            isBobina: false,
        },
        sanitize: {
            keepChildren: ['Empresa', 'NCM', 'Fabricante', 'produtoBens', 'produtoEmbalagens', 'produtoImagens'],
        },
    },
};
